export default "__VITE_ASSET__em3WT7KQ__"